// شیفت‌ها — reading the clinic's presence rows.
//
// Two facts from the scheduling contract that a screen must not re-guess:
//
//   dayOfWeek is 0 = MONDAY … 6 = SUNDAY. It is NOT JS's getDay() (0 = Sunday)
//   and it is NOT the Iranian week (which starts on شنبه). A wrong base here
//   puts a dentist's Saturday shift on a Monday and nothing else breaks, so
//   nothing else catches it.
//
//   startTimeMinutes / endTimeMinutes are Iran wall-clock minutes from midnight,
//   already local. They are NOT epochs and must not go through iranTime.js.
//
// Presence is READ-ONLY in this app: the clinic owns the shift, and the BFF
// exposes no write. Nothing here builds an editable model.

/** The catalogue key for a weekly day. null for a one-off (dayOfWeek -1). */
export function presenceDayKey(dayOfWeek) {
  const n = Number(dayOfWeek);
  return Number.isInteger(n) && n >= 0 && n <= 6 ? `profile.presence.days.${n}` : null;
}

/**
 * Minutes-from-midnight → 'HH:MM'. Anything that is not a usable minute yields
 * '' — including null and '', which `Number()` would happily turn into 0 and so
 * into a confident, wrong «۰۰:۰۰».
 */
export function minutesToClock(minutes) {
  if (minutes == null || minutes === '') return '';
  const n = Number(minutes);
  if (!Number.isFinite(n) || n < 0 || n > 24 * 60) return '';
  const h = Math.floor(n / 60);
  const m = Math.round(n % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Length of a shift in minutes; null when the row is not a usable interval. */
export function shiftLength(presence) {
  const start = Number(presence?.startTimeMinutes);
  const end = Number(presence?.endTimeMinutes);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
  return end - start;
}

/**
 * Weekly shifts first, in week order, then one-off dates by their date.
 * Within a day, earliest start first — the order a week is read in.
 */
export function sortPresences(list) {
  return [...(list || [])].sort((a, b) => {
    const da = Number(a?.dayOfWeek);
    const db = Number(b?.dayOfWeek);
    const wa = da >= 0 ? 0 : 1;
    const wb = db >= 0 ? 0 : 1;
    if (wa !== wb) return wa - wb;
    if (wa === 0 && da !== db) return da - db;
    if (wa === 1) {
      const sa = Number(a?.specificDate) || 0;
      const sb = Number(b?.specificDate) || 0;
      if (sa !== sb) return sa - sb;
    }
    return (Number(a?.startTimeMinutes) || 0) - (Number(b?.startTimeMinutes) || 0);
  });
}
